import Highcharts from './_highcharts-base';

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(() => {
        for (const chartLegend of $('#norm-chart-legend')) {
            const chart = Highcharts.charts[$(".norm-chart").data('highchartsChart')];
            const chartColors = chart.options.colors;
            // Series with 'name' attribute is a reference profile series
            const profileSeries = chart.options.series.filter((s) => s.hasOwnProperty('name'));
            let html = '';
            let i = 1;
            for (const s of profileSeries) {
                const profileLabel = s.name;
                const profileColor = chartColors[i];
                if ((i % 2) !== 0) {
                    html += '<tr>';
                }
                html += getReferenceProfileRow(profileLabel, profileColor);
                if ((i === profileSeries.length - 1) && (profileSeries.length % 2) !== 0) {
                    html += '<td></td><td></td></tr>';
                } else if ((i % 2) === 0) {
                    html += '</tr>';
                }
                i++;
            }
            $(chartLegend).find('table tr:first').after(html);
        }
    });
}

/**
 * Returns the html code of two table cells that represent the reference profile.
 * The first cell contains the (diamond) symbol with the given color and the
 * second cell contains the textual description.
 */
function getReferenceProfileRow(profileDescription: string, profileColor: string): string {
    return '<td>' + getSymbol(profileColor) + '</td><td>' + profileDescription + '</td>';
}

/**
 * Returns the svg code of the symbol with the given color.
 */
function getSymbol(color: string): string {
    return '<svg width="20" height="20">' +
        '<path fill="none" d="M 0 11 L 16 11" stroke="' + color + '" stroke-width="1"></path>' +
        '<path fill="' + color + '" d="M 8 5 L 14 11 8 17 2 11 Z"></path>' +
        '</svg>';
}